import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import VideoPlayer from '@components/Video/VideoPlayer';
import styles from '@components/VideoModal/VideoModal.styles';
import { useResponsive } from '@features/responsive';
import theme from '@styles/theme';
import LayoutUiState from '@features/layout/mobX/LayoutUiState';
import { IVideoType } from '@components/typescript';
type PropsType = {
  active: boolean;
  closeModalFunc: (boolean) => void;
  video: IVideoType;
  thumbnail?: string;
};
const VideoModal = ({
  active,
  closeModalFunc,
  video,
  thumbnail = ''
}: PropsType) => {
  const [poster, setPoster] = useState(thumbnail || '');
  const {
    isNarrowerThanDesktop,
    currentBreakpoint
  } = useResponsive();
  const {
    setVideoModalOpened
  } = LayoutUiState;
  useEffect(() => {
    setVideoModalOpened(active);
  }, [active]);
  const handleCloseModal = () => {
    setVideoModalOpened(false);
    closeModalFunc(false);
  };
  useEffect(() => {
    const handlePopState = () => {
      handleCloseModal();
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', handlePopState);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('popstate', handlePopState);
      }
    };
  }, []);
  useEffect(() => {
    if (typeof video !== 'string' && typeof video.desktop !== 'string') {
      if (currentBreakpoint) {
        setPoster(video[currentBreakpoint]?.poster || thumbnail || '');
      } else {
        setPoster(video.desktop.poster || thumbnail || '');
      }
    }
  }, [video]);
  return <div sx={styles.modalContainer(active)}>
      <span sx={styles.closeButton}>
        <Button variant="iconOnly" onClick={handleCloseModal}>
          <Icon icon="Close3" size={isNarrowerThanDesktop ? '24px' : '40px'} color={theme.rawColors.darkGrey700} />
        </Button>
      </span>
      <VideoPlayer video={video} playVideo={active} withSound controls fullscreen poster={poster} />
    </div>;
};
export default observer(VideoModal);